<template>
  <div>
    <!-- 日历票授权弹框开始 -->

    <el-dialog :close-on-click-modal="false"
      title="期票授权"
      :visible.sync="dataAuthorDialogVisible"
      :before-close="dataAuthorHandleClose"
      width="53.2%"
      center
    >
      <el-divider></el-divider>
      <div class="titleSear">
        <el-input placeholder="请输入内容" v-model="data.name" clearable></el-input>
        <el-button @click="btns">查询</el-button>
      </div>
      <div class="contentQp">
        <div class="qpLeft">
          <div v-for="(item,index) in notEmpow" :key='index' class="empow">
            <el-checkbox v-model="item.checked"  @change="$forceUpdate()"></el-checkbox>
            <span style="margin-left:1rem;">{{ item.ProductName }}</span>
          </div>
        </div>
        <div class="qpCenter">
          <el-form ref="form" :model="form"  label-width="80px" :label-position="labelPosition">
            <el-form-item label="代理价" prop="AgentPrice">
              <el-input v-model="form.AgentPrice" placeholder="请输入代理价"></el-input>
            </el-form-item>
            <el-form-item label="每日代理数量" prop="DayNumber">
              <el-input v-model="form.DayNumber" placeholder="请输入每日代理数量"></el-input>
            </el-form-item>
            <el-form-item label="总代理数量" prop="AllNumber">
              <el-input v-model="form.AllNumber" placeholder="请输入总代理数量"></el-input>
            </el-form-item>
          </el-form>
          <div class="qpCenterBtn">
            <div>
              <button @click="select('form')">选择</button>
              <button @click="select1()">全部选择</button>
            </div>
            <div>
              <button @click="cancel">取消</button>
              <button @click="cancel('1')">全部取消</button>
            </div>
          </div>
        </div>
        <div class="qpRight">
          <div v-for="(item,index) in empower" :key="index" class="empow" >
            <el-checkbox v-model="item.checked"   @change="$forceUpdate()"></el-checkbox>
            <span style="margin-left:1rem;">{{ item.ProductName }}</span>
            <span>--代理价：{{ item.AgentPrice }}</span>
            <span>--每日数量：{{ item.DayNumber }}</span>
            <span>--总数量：{{ item.AllNumber }}</span>
          </div>
          <div>
            <span>注:</span>
            <span>数量为0的话就是不限制销售数量</span>
          </div>
        </div>
      </div>
      <div class="itemBtnS">
       
        <el-button class="btnL" @click="Setempower">确认授权</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProductAndDistributortwoList,
  impowerDistrbutorTwoProduct,
  getProductDistributorList
} from "@/request/distributor.js"
import { Message } from "element-ui";
export default {
  data() {
    return {
      is_impower:'1',
      dataAuthorDialogVisible: false, // 期票授权
      options: [
        {
          value:'1',
          label:'上线'
        },
        {
          value:'2',
          label:'下线'
        }
      ],
      value: "",
      input: "",
      form: {
        token:window.sessionStorage.getItem('Token'),
        distrbutortwo_id:'',
        ProductID:'',
        AgentPrice:'',
        DayNumber:'',
        AllNumber:''
      },
      rules:{
        AgentPrice:[  { required: true, message: '请输入代理价', trigger: 'blur' }],
        DayNumber:[  { required: true, message: '请输入每天限制购买数量', trigger: 'blur' }],
        AllNumber:[  { required: true, message: '请输入总限制数量', trigger: 'blur' }]
      },
      labelPosition: "top",
      data:{
        token:window.sessionStorage.getItem('Token'),
        distributortwoid:'',
        is_impower:'1',
        type:0,
        name:'',
        UseFlag:'0',
      },
      empower:[], // 授权
      notEmpow:[], // 未授权
      Product:[],
      opti:[]
    };
  },
  created(){
    this.getList()
  },
  methods: {
    getList(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:99
      }
      getProductDistributorList(data).then(res=>{
        if(res.data.status=='ok'){
          this.opti = res.data.result.data
        }
      })
    },
    // 授权接口
    getDetailem(){
      getProductAndDistributortwoList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.empower = res.data.result
          this.empower.map(item=>{
            item.checked = false
          })
        }else{
          this.empower = [ ]
        }
      })
    },
    // 未授权
    getDetailnot(){
      this.data.is_impower = '2'
      getProductAndDistributortwoList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.notEmpow = res.data.result
          this.notEmpow.map(item=>{
            item.checked = false
          })
        }else{
          this.notEmpow = [ ]
        }
      })
    },
    // 查询
    btns(){
      console.log(this.is_impower,111)
      if(this.is_impower=='1'){
        this.data.is_impower = '1'
        this.getDetailem()
      }else if(this.is_impower=='2'){
        this.data.is_impower = '2'
        this.getDetailnot()
      }else{
        this.data.is_impower= '1'
        this.getDetailem()
        this.getDetailnot()
      }
    },
    // 提交授权
    Setempower(){
      let form = {
        token:window.sessionStorage.getItem('Token'),
        distrbutortwo_id:this.data.distributortwoid,
        AgentPrice:'',
        DayNumber:'',
        AllNumber:'',
        ProductID:''
      }
      this.empower.map(item=>{
        form.ProductID += item.ProductID + ','
        form.AgentPrice += item.AgentPrice + ','
        form.DayNumber += item.DayNumber +','
        form.AllNumber += item.AllNumber + ','
      })
      if (form.ProductID.length > 0) {
        form.ProductID  = form.ProductID.substr(0,form.ProductID.length - 1);
      }
      if (form.AgentPrice.length > 0) {
        form.AgentPrice = form.AgentPrice.substr(0,form.AgentPrice.length - 1);
      }
      if (form.DayNumber.length > 0) {
          form.DayNumber = form.DayNumber.substr(0, form.DayNumber.length - 1);
      }
      if (form.AllNumber.length > 0) {
          form.AllNumber = form.AllNumber.substr(0, form.AllNumber.length - 1);
      }
      impowerDistrbutorTwoProduct(form).then(res=>{
        if(res.data.status=='ok'){
          Message.success('授权成功')
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    // 期票授权
    dataAuthor(row) {
      this.dataAuthorDialogVisible = true;
      this.data.distributortwoid = row.DistributorID
      this.getDetailem()
      this.getDetailnot()
    },
    select1(){
      if(this.form.AgentPrice!=''){
          if(this.form.AgentPrice<=0){
            Message.error('代理价不能小余0')
            return false
          }
      }
      this.notEmpow.map(item=>{
          item.checked = true
      })
      this.notEmpow.map((item,index)=>{
        if(item.checked){
          // console.log(this.form.AgentPrice,item)A
          item.AgentPrice = this.form.AgentPrice!=''?this.form.AgentPrice:item.AgentPrice
          item.DayNumber = this.form.DayNumber!=''?this.form.DayNumber:item.DayNumber
          item.AllNumber = this.form.AllNumber!=''?this.form.AllNumber:item.AllNumber
          this.empower.push(item)
        }
      })
      // console.log(this.empower)
      for(let i=this.notEmpow.length-1;i>=0;i--){
          if(this.notEmpow[i].checked){
          this.notEmpow.splice(i, 1);
        }
      }
      this.form.AgentPrice = ''
      this.form.DayNumber = ''
      this.form.AllNumber = ''
    },
    // 选择
    select(form,type){
      if(this.form.AgentPrice!=''){
          if(this.form.AgentPrice<=0){
            Message.error('代理价不能小于0')
            return false
          }
      }
        this.notEmpow.map((item,index)=>{
            if(item.checked){
              // item.AgentPrice = this.form.AgentPrice
              // item.DayNumber = this.form.DayNumber
              // item.AllNumber = this.form.AllNumber
              item.AgentPrice = this.form.AgentPrice!=''?this.form.AgentPrice:item.AgentPrice
              item.DayNumber = this.form.DayNumber!=''?this.form.DayNumber:item.DayNumber
              item.AllNumber = this.form.AllNumber!=''?this.form.AllNumber:item.AllNumber
              item.checked = true
              this.empower.push(item)
            }
          })
          for(let i=this.notEmpow.length-1;i>=0;i--){
              if(this.notEmpow[i].checked){
              this.notEmpow.splice(i, 1);
            }
          }
          this.empower.map(item=>{
            item.checked = false
          })
          this.notEmpow.map(item=>{
            item.checked = false
          })
          this.form.AgentPrice = ''
          this.form.DayNumber = ''
          this.form.AllNumber = ''
    },
    // 取消
    cancel(type){
      if(type=='1'){
        this.empower.map(item=>{
          item.checked = true
        })
      }
      this.empower.map(item=>{
        if(item.checked){
          this.notEmpow.push(item)
        }
      })
      for(let i=this.empower.length-1;i>=0;i--){
          if(this.empower[i].checked){
            this.empower.splice(i, 1);
          }
      }
      this.notEmpow.map(item=>{
        item.checked = false
      })
    },
    // 期票授权X
    dataAuthorHandleClose() {
      this.$emit('impowerClose')
      this.dataAuthorDialogVisible = false;
    }
  }
};
</script>

<style lang='less' scoped>
.itemBtnS {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 20px;
  /deep/.el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
.contentQp {
  width: 100%;
  height: 490px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  .qpLeft {
    width: 40%;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
  }
  .qpCenter {
    width: 15%;
    height: 490px;
    background: #ffffff;
    border-radius: 4px;

    .qpCenterBtn {
      > div:nth-child(1) {
        width: 100%;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        button {
          width:  100%;
          height: 40px;
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #246deb;
          cursor: pointer;
          margin-bottom: 20px;
        }
      }
      > div:nth-child(2) {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        button {
          width: 100%;
          height: 40px;
          background: #ffffff;
          border: 1px solid #e74c3c;
          border-radius: 4px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #e74c3c;
          margin-bottom: 20px;
          cursor: pointer;
        }
      }
    }
    /deep/.el-form-item {
      margin-bottom: 1rem;
    }
    /deep/.el-form-item__label {
      text-align: right;
      vertical-align: middle;
      float: left;
      line-height: 30px;
      padding: 0 12px 0 0;
      box-sizing: border-box;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
  .qpRight {
    width: 40%;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
    > div:last-child {
      margin-top: 2rem;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #e74c3c;
      span {
        margin-right: 10px;
      }
    }
  }
}
.titleSear {
  display: flex;
  .sel {
    margin-right: 20px;
  }
  .el-select {
    width: 260px;
  }
  .el-input {
    width: 300px;
    margin: 0 20px 0 0 ;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
  }
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
.empow{
  color: #666666;
  font-size: 1.4rem;
  margin:0 2.1rem  1.8rem 0;
  cursor: pointer;
}
/deep/ .el-dialog{
  min-width: 700px !important;
}
</style>